module.exports = __webpack_public_path__ + "img/logo.95c86b81.jpg";